import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import tiffinService from '../services/tiffinService';

const TiffinCenter = () => {
  const navigate = useNavigate();
  const [centers, setCenters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [countryId, setCountryId] = useState(1);

  useEffect(() => {
    fetchCenters();
  }, [countryId]);

  const fetchCenters = async () => {
    try {
      setLoading(true);
      const data = await tiffinService.getCenters(countryId);
      setCenters(data || []);
      setError(null);
    } catch (err) {
      setError('Failed to load centers. Please try again later.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectCenter = (centerId) => {
    navigate(`/tiffin/selection?centerId=${centerId}`);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container-custom">
        <div className="mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Select Tiffin Center</h1>
          <p className="text-lg text-gray-600">
            Choose a center to view available meal plans
          </p>
        </div>

        <div className="mb-8">
          <label className="form-label">Select Country</label>
          <select
            value={countryId}
            onChange={(e) => setCountryId(parseInt(e.target.value))}
            className="form-input"
          >
            <option value={1}>USA</option>
            <option value={2}>Canada</option>
          </select>
        </div>

        {loading && (
          <div className="text-center py-12">
            <div className="inline-block">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
            <p className="mt-4 text-gray-600">Loading centers...</p>
          </div>
        )}

        {error && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
            <p className="text-red-800">{error}</p>
          </div>
        )}

        {!loading && centers.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {centers.map((center) => (
              <div
                key={center.centerId}
                className="item-card cursor-pointer p-8"
                onClick={() => handleSelectCenter(center.centerId)}
              >
                <div className="text-center mb-6">
                  <div className="text-6xl mb-4">🍱</div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">
                    {center.centerName}
                  </h3>
                  <p className="text-gray-600 text-sm font-semibold">
                    📍 {center.centerCity}, {center.centerState}
                  </p>
                </div>
                <p className="text-gray-700 mb-6 text-sm leading-relaxed text-center">
                  {center.centerDescription}
                </p>
                <button className="w-full bg-gradient-to-r from-orange-600 to-red-600 hover:from-orange-700 hover:to-red-700 text-white font-bold py-3 px-4 rounded-xl transition transform hover:shadow-lg">
                  View Plans →
                </button>
              </div>
            ))}
          </div>
        )}

        {!loading && centers.length === 0 && !error && (
          <div className="text-center py-12">
            <p className="text-gray-600 text-lg">No centers available for the selected country.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TiffinCenter;
